// components/Application/ApplicationSections.jsx
import React, { useState } from 'react';
import MyApplicationsCard from './MyApplicationsCard';
import SelfTrackingApplicationCard from './SelfTrackingApplicationCard';
import ContactModal from '../ContactModal/ContactModal.jsx';
import styles from './Application.module.css';

const ApplicationSections = ({
  nativeApplications,
  selfTrackingApplications,
  onWithdraw,
  onUpdateSelfTracking,
  onEditSelfTracking, // Add this prop
  onAddSelfTracking
}) => {
  const [selectedProfessor, setSelectedProfessor] = useState(null);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleContactClick = (professor) => {
    setSelectedProfessor(professor);
    setIsContactModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsContactModalOpen(false);
    setSelectedProfessor(null);
  };

  return (
    <>
      <div className={styles.applicationSections}>
      {/* NeuHawk Native Positions Section */}
      <section className={styles.applicationSection}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>
            NeuHawk Native Positions
            <span className={styles.sectionCount}>({nativeApplications.length})</span>
          </h2>
          <p className={styles.sectionDescription}>
            Applications submitted through NeuHawk are automatically tracked and updated
          </p>
        </div>
        <div className={styles.applicationsGrid}>
          {nativeApplications.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>🎯</div>
              <h3>No Native Applications Yet</h3>
              <p>Applications submitted through NeuHawk will appear here</p>
            </div>
          ) : (
            nativeApplications.map(application => (
              <MyApplicationsCard
                key={application._id}
                application={application}
                onWithdraw={(id) => onWithdraw(id, true)} // Pass isNative = true
                onContactClick={handleContactClick}
                isNative={true}
              />
            ))
          )}
        </div>
      </section>

      {/* Self-tracking Positions Section */}
      <section className={styles.applicationSection}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>
            Self-tracking Positions
            <span className={styles.sectionCount}>({selfTrackingApplications.length})</span>
          </h2>
          <p className={styles.sectionDescription}>
            Manually track applications submitted on external sites
          </p>
          <button
            className={styles.addSelfTrackingBtn}
            onClick={onAddSelfTracking}
          >
            + Add External Application
          </button>
        </div>
        <div className={styles.applicationsGrid}>
          {selfTrackingApplications.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>📝</div>
              <h3>No Self-tracking Applications</h3>
              <p>Add applications from external sites to track them here</p>
              <button
                className={styles.browsePositionsBtn}
                onClick={onAddSelfTracking}
              >
                Add Your First Application
              </button>
            </div>
          ) : (
            selfTrackingApplications.map(application => (
              <SelfTrackingApplicationCard
                key={application._id}
                application={application}
                onUpdate={onUpdateSelfTracking}
                onEdit={onEditSelfTracking} // Add this prop
                onWithdraw={(id) => onWithdraw(id, false)} // Pass isNative = false
              />
            ))
          )}
        </div>
      </section>
      </div>

      {/* Contact Modal - rendered at section level to cover entire area */}
      {selectedProfessor && (
        <ContactModal
          professor={selectedProfessor}
          isOpen={isContactModalOpen}
          onClose={handleCloseModal}
          onMessageSent={() => {
            console.log("Message sent successfully");
            handleCloseModal();
          }}
        />
      )}
    </>
  );
};

export default ApplicationSections;